export default "__VITE_ASSET__ccO4jLS7__"